// extracted by mini-css-extract-plugin
export var container = "OurLeadershipTeam-module__container___ywS58";
export var content = "OurLeadershipTeam-module__content___TWhmR";
export var copy = "OurLeadershipTeam-module__copy___itsdR";
export var heading = "OurLeadershipTeam-module__heading___Oy4IU";
export var leaders = "OurLeadershipTeam-module__leaders___P7wov";
export var link = "OurLeadershipTeam-module__link___ZlYjF";